import React from "react";

import { ContribBucketAggregationValuesElement } from "@external_datasets_search/components";

const BucketAggregationValuesElement = ({ bucket, ...rest }) => {
  return (
    <ContribBucketAggregationValuesElement
      bucket={{ ...bucket, key: bucket.key.toString() }}
      {...rest}
    />
  );
};

export default BucketAggregationValuesElement;
